var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoanDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.9584H5.83341C2.15841 18.9584 1.04175 17.8417 1.04175 14.1667V5.83341C1.04175 2.15841 2.15841 1.04175 5.83341 1.04175H7.08341C8.54175 1.04175 9.00008 1.51675 9.58341 2.29175L10.8334 3.95841C11.1084 4.32508 11.1501 4.37508 11.6667 4.37508H14.1667C17.8417 4.37508 18.9584 5.49175 18.9584 9.16675V14.1667C18.9584 17.8417 17.8417 18.9584 14.1667 18.9584ZM5.83341 2.29175C2.85008 2.29175 2.29175 2.85841 2.29175 5.83341V14.1667C2.29175 17.1417 2.85008 17.7084 5.83341 17.7084H14.1667C17.1501 17.7084 17.7084 17.1417 17.7084 14.1667V9.16675C17.7084 6.19175 17.1501 5.62508 14.1667 5.62508H11.6667C10.6001 5.62508 10.2501 5.25841 9.83342 4.70841L8.58341 3.04175C8.15008 2.46675 8.01675 2.29175 7.08341 2.29175H5.83341Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5.94175C16.3251 5.94175 16.0417 5.65841 16.0417 5.31675V4.16675C16.0417 2.85008 15.4834 2.29175 14.1667 2.29175H6.66675C6.32508 2.29175 6.04175 2.00841 6.04175 1.66675C6.04175 1.32508 6.32508 1.04175 6.66675 1.04175H14.1667C16.1834 1.04175 17.2917 2.15008 17.2917 4.16675V5.31675C17.2917 5.65841 17.0084 5.94175 16.6667 5.94175Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanDocuments);
export default __webpack_public_path__ + "static/media/loan-documents.540038d12e889576cda5ba2c25de91fa.svg";
export { ForwardRef as ReactComponent };